// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  INSIGHTS: '/insights',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    verify: `${ROOTS.AUTH}/verify`,
    signUp: `${ROOTS.AUTH}/sign-up`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    reports: {
      root: `${ROOTS.DASHBOARD}/reports`,
    },
    iam: {
      root: `${ROOTS.DASHBOARD}/iam`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/iam/${id}/edit`,
      newManager: `${ROOTS.DASHBOARD}/iam/new-manager`,
    },
    locations: {
      root: `${ROOTS.DASHBOARD}/locations`,
      newLocation: `${ROOTS.DASHBOARD}/locations/new-location`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/locations/${id}/edit`,
    },
    orders: {
      root: `${ROOTS.DASHBOARD}/orders`,
      newOrder: `${ROOTS.DASHBOARD}/orders/new-order`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/orders/${id}`,
    },
    customers: {
      root: `${ROOTS.DASHBOARD}/customers`,
      newCustomer: `${ROOTS.DASHBOARD}/customers/new-customer`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/customers/${id}/edit`,
      customer: (id: string) => ({
        root: `${ROOTS.DASHBOARD}/customers/${id}`,
        transactions: `${ROOTS.DASHBOARD}/customers/${id}/transactions`,
        giftCards: `${ROOTS.DASHBOARD}/customers/${id}/gift-cards`,
        notes: `${ROOTS.DASHBOARD}/customers/${id}/notes`,
        pushNotifications: `${ROOTS.DASHBOARD}/customers/${id}/push-notifications`,
      }),
    },
    products: {
      root: `${ROOTS.DASHBOARD}/products`,
      manageStock: `${ROOTS.DASHBOARD}/products/manage-stock`,
      manageProductSettings: `${ROOTS.DASHBOARD}/products/manage-product-settings`,
      newProduct: `${ROOTS.DASHBOARD}/products/new-product`,
      product: (id: string) => `${ROOTS.DASHBOARD}/products/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/products/${id}/edit`,
    },
    modifiers: {
      root: `${ROOTS.DASHBOARD}/modifiers`,
      newModifier: `${ROOTS.DASHBOARD}/modifiers/new-modifier`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/modifiers/${id}/edit`,
    },
    categories: {
      root: `${ROOTS.DASHBOARD}/categories`,
      mainCategories: `${ROOTS.DASHBOARD}/categories/main-categories`,
      subCategories: `${ROOTS.DASHBOARD}/categories/sub-categories`,
    },
    giftcards: {
      root: `${ROOTS.DASHBOARD}/giftcards`,
      manageGiftCardVariants: `${ROOTS.DASHBOARD}/giftcards/manage-gift-card-variants`,
      view: (id: string) => `${ROOTS.DASHBOARD}/giftcards/${id}`,
    },
    balanceTransfers: {
      root: `${ROOTS.DASHBOARD}/balance-transfers`,
      view: (id: string) => `${ROOTS.DASHBOARD}/balance-transfers/${id}`,
    },
    rewards: {
      root: `${ROOTS.DASHBOARD}/rewards`,
    },
    offers: {
      root: `${ROOTS.DASHBOARD}/offers`,
    },
    events: {
      root: `${ROOTS.DASHBOARD}/events`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/events/${id}/edit`,
    },
    notifications: {
      root: `${ROOTS.DASHBOARD}/notifications`,
    },
    appSettings: {
      root: `${ROOTS.DASHBOARD}/app-settings`,
      productSettings: `${ROOTS.DASHBOARD}/app-settings/product-settings`,
    },
    syncAccount: {
      root: `${ROOTS.DASHBOARD}/sync-account`,
    },
  },
  insights: {
    root: ROOTS.INSIGHTS,
    customers: {
      root: `${ROOTS.INSIGHTS}/customers`,
      repeatRates: `${ROOTS.INSIGHTS}/customers/repeat-rates`,
      trafficSummary: `${ROOTS.INSIGHTS}/customers/traffic-summary`,
      activeUsers: `${ROOTS.INSIGHTS}/customers/active-users`,
      avgMonthlyFrequency: `${ROOTS.INSIGHTS}/customers/avg-monthly-frequency`,
      repeatCustomersWithinXDays: `${ROOTS.INSIGHTS}/customers/repeat-customers-within-x-days`,
      averageLTV: `${ROOTS.INSIGHTS}/customers/average-ltv`,
      promoSignUpStats: `${ROOTS.INSIGHTS}/customers/promo-signup-stats`,
    },
    products: {
      root: `${ROOTS.INSIGHTS}/products`,
    },
    categories: {
      root: `${ROOTS.INSIGHTS}/categories`,
    },
    stores: {
      root: `${ROOTS.INSIGHTS}/stores`,
    },
    promotions: {
      root: `${ROOTS.INSIGHTS}/promotions`,
    },
  },
};
